import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type AcceptSuggestionMutationVariables = GraphQLTypes.Exact<{
  suggestionId: GraphQLTypes.Scalars['String']['input'];
}>;

export type AcceptSuggestionMutationResult = { __typename?: 'Mutation' } & {
  acceptSuggestion?: GraphQLTypes.Maybe<
    { __typename?: 'AcceptSuggestionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const AcceptSuggestionDocument = gql`
  mutation acceptSuggestion($suggestionId: String!) {
    acceptSuggestion(suggestionId: $suggestionId) {
      errors {
        message
      }
    }
  }
`;
